var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.6799C2.5 6.01524 2.5 4.68291 2.8146 4.23469C3.12919 3.78646 4.38194 3.35765 6.88743 2.50001L7.36477 2.33661C8.67082 1.88955 9.32384 1.66602 10 1.66602C10.6762 1.66602 11.3292 1.88955 12.6352 2.33661L13.1126 2.50001C15.6181 3.35765 16.8708 3.78646 17.1854 4.23469C17.5 4.68291 17.5 6.01524 17.5 8.6799C17.5 9.08239 17.5 9.51886 17.5 9.99215C17.5 14.6905 13.9675 16.9706 11.7512 17.9387C11.15 18.2014 10.8494 18.3327 10 18.3327C9.15062 18.3327 8.85001 18.2014 8.2488 17.9387C6.03247 16.9706 2.5 14.6905 2.5 9.99215C2.5 9.51886 2.5 9.08239 2.5 8.6799Z",
    stroke: "#2058E7",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91699 10.334L9.10747 11.6673L12.0837 8.33398",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSuccess);
export default __webpack_public_path__ + "static/media/LoginSuccess.023a097d8320092f96950f3e97428f19.svg";
export { ForwardRef as ReactComponent };